module.exports = __webpack_public_path__ + "assets/img/promiseImg (1).cb7cc6bb.png";